var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-select',{attrs:{"items":_vm.templateItemList,"ready":_vm.ready,"required":_vm.required,"label":"申請種別","inline-label":""},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }